"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityProvider = void 0;
var react_1 = __importStar(require("react"));
var identity_1 = require("@workspace/identity");
var IdentityContext_1 = require("./IdentityContext");
var IdentityState_1 = require("./IdentityState");
var utils_1 = require("./utils");
var defaultOnSigninCallback = function (appState) {
    window.history.replaceState({}, document.title, appState && appState.returnTo ? appState.returnTo : window.location.pathname);
};
/**
 * ```jsx
 * <IdentityProvider
 *   domain={domain}
 *   clientId={clientId}
 *   redirectUri={window.location.origin}
 * >
 *   <MyApp />
 * </IdentityProvider>
 * ```
 *
 * Provides the IdentityContext to its child components.
 */
var IdentityProvider = function (props) {
    var client = (0, react_1.useState)(function () { return new identity_1.IdentityClient(props); })[0];
    var _a = (0, react_1.useState)(IdentityState_1.initialIdentityState), authState = _a[0], setAuthState = _a[1];
    var _b = props.onSigninCallback, onSigninCallback = _b === void 0 ? defaultOnSigninCallback : _b;
    (0, react_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var user_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(client.signinFlow === "silent")) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, client.checkSession()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, client.getUser()];
                    case 3:
                        user_1 = _a.sent();
                        setAuthState(function (a) {
                            return __assign(__assign({}, a), { user: user_1, error: undefined, isAuthenticated: user_1 !== undefined ? true : false, isError: false, isLoading: false, status: user_1 !== undefined ? "authenticated" : "unauthenticated" });
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        setAuthState(function (a) {
                            return __assign(__assign({}, a), { error: error_1, isError: true, isLoading: false, status: "error" });
                        });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); })();
    }, [client]);
    var hasDoneInteractiveSignin = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (!client || hasDoneInteractiveSignin.current) {
            return;
        }
        hasDoneInteractiveSignin.current = true;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var oidcUser, user_2, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(client.signinFlow === "interactive")) return [3 /*break*/, 6];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        if (!(0, utils_1.hasAuthParams)()) return [3 /*break*/, 3];
                        return [4 /*yield*/, client.signinCallback()];
                    case 2:
                        oidcUser = _a.sent();
                        onSigninCallback(oidcUser.state, oidcUser);
                        _a.label = 3;
                    case 3: return [4 /*yield*/, client.getUser()];
                    case 4:
                        user_2 = _a.sent();
                        setAuthState(function (a) {
                            return __assign(__assign({}, a), { user: user_2, error: undefined, isAuthenticated: user_2 !== undefined ? true : false, isError: false, isLoading: false, status: user_2 !== undefined ? "authenticated" : "unauthenticated" });
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        error_2 = _a.sent();
                        setAuthState(function (a) {
                            return __assign(__assign({}, a), { error: error_2, isAuthenticated: false, isError: true, status: "error" });
                        });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); })();
    }, [client, onSigninCallback]);
    (0, react_1.useEffect)(function () {
        // event UserLoaded (e.g. initial load, silent renew success)
        var handleUserLoaded = function (user) {
            setAuthState(function (a) {
                return __assign(__assign({}, a), { error: undefined, isAuthenticated: user !== undefined ? true : false, isError: false, isLoading: false, status: user !== undefined ? "authenticated" : "unauthenticated" });
            });
        };
        // event UserUnloaded (e.g. userManager.removeUser)
        var handleUserUnloaded = function () {
            setAuthState(function (a) {
                return __assign(__assign({}, a), { error: undefined, isAuthenticated: false, isError: false, isLoading: true, status: "unauthenticated" });
            });
        };
        // event SilentRenewError (silent renew error)
        var handleSilentRenewError = function (error) {
            setAuthState(function (a) {
                return __assign(__assign({}, a), { error: error, isAuthenticated: false, isError: true, status: "error" });
            });
        };
        if (client.signinFlow === "interactive") {
            client.events.addUserLoaded(handleUserLoaded);
            client.events.addUserUnloaded(handleUserUnloaded);
            client.events.addUserSignedOut(handleUserUnloaded);
            client.events.addSilentRenewError(handleSilentRenewError);
        }
        return function () {
            if (client.signinFlow === "interactive") {
                client.events.removeUserLoaded(handleUserLoaded);
                client.events.removeUserUnloaded(handleUserUnloaded);
                client.events.removeUserSignedOut(handleUserUnloaded);
                client.events.removeSilentRenewError(handleSilentRenewError);
            }
        };
    }, [client]);
    var getAccessToken = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, client.getAccessToken()];
                case 1:
                    token = _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    setAuthState(function (a) {
                        return __assign(__assign({}, a), { error: error_3, isAuthenticated: false, isError: true, status: "error" });
                    });
                    throw "Get access token failed";
                case 3: return [2 /*return*/, token !== null && token !== void 0 ? token : ""];
            }
        });
    }); }, [client]);
    var signinRedirect = (0, react_1.useCallback)(function (args) {
        return client.signinRedirect(args);
    }, [client]);
    var requestReauthentication = (0, react_1.useCallback)(function () {
        client.requestReauthentication();
    }, [client]);
    return (react_1.default.createElement(IdentityContext_1.IdentityContext.Provider, { value: __assign(__assign({}, authState), { getAccessToken: getAccessToken, requestReauthentication: requestReauthentication, signinRedirect: signinRedirect }) }, props.children));
};
exports.IdentityProvider = IdentityProvider;
